import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { EatingWayAreaImage } from './models';

const eatingWayAreaImageService = {
  getItem(id: number): Promise<CommonResponse<EatingWayAreaImage>> {
    const url = `/eating-way-area-image/${id}`;
    return axiosClient.get(url);
  },
  update(id: number, payload: Partial<EatingWayAreaImage>): Promise<CommonResponse<any>> {
    const url = `/eating-way-area-image/${id}`;
    return axiosClient.patch(url, payload);
  },
  add(payload: Partial<EatingWayAreaImage>): Promise<CommonResponse<any>> {
    const url = `/eating-way-area-images`;
    return axiosClient.post(url, payload);
  },
};

export default eatingWayAreaImageService;
